import request from '../untils/request';

export const operatioFeedbackApi = params => {
  return request({
    url: '/operation/feedback/index',
    authCode: 'SUPPORT_INDEX',
    params,
  });
};

export const operatioFeedbackReplyApi = params => {
  return request({
    url: '/operation/feedback/reply',
    authCode: 'SUPPORT_INDEX',
    params,
  });
};

export const operationFeedbackDetailApi = params => {
  return request({
    url: '/operation/feedback/detail',
    authCode: 'SUPPORT_INDEX',
    params,
  });
};

export const operationFeedbackConfirmApi = params => {
  return request({
    url: '/operation/feedback/confirm',
    authCode: 'SUPPORT_INDEX',
    params,
  });
};
